export default __webpack_public_path__ + "static/media/Oakshelter.b7fec5d6.jpg";